module.exports = __webpack_public_path__ + "assets/images/clt_g.e2959edc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/clt_g.png
// module id = 690
// module chunks = 1